import { createContext } from "@smartsheet/lodestar-utils";
/**
 * This is used to plumb the validation state from the public API to the
 * places where it's used.
 *
 * @deprecated This component is being removed in V6+, February 2025, in favor of the `SelectV2/MultiSelectV2` components.
 */
export const ValidationContext = createContext("default", "ValidationContext");
//# sourceMappingURL=ValidationContext.js.map